import {Form} from "../../helpers/forms/Form";
import {initFlatPickerInput} from "../../helpers/inputs/flatPicker/flatPicker";

class ProductionForm extends Form {

	constructor(config) {
		super({
			fields: [
				'name',
				'start_date',
				'performances',
			],
			...config,
		});


		// Init flatpickr instance
		const dateInput = this.config.formElement.querySelector('input[name="start_date"]');
		initFlatPickerInput(dateInput, {
			enableTime: false,
		});
	}
}

export {ProductionForm}
